const typingElements = document.querySelectorAll('.typing-element')

typingElements.forEach(element => {
	let i = 1
	let typed = false
	const speed = 50

	// Check position of the element
	const elementPosition = element.getBoundingClientRect().top
	let windowScrollPosition = window.scrollY + window.innerHeight

	// As the name says
	const runTyping = element => {
		if (windowScrollPosition > elementPosition && !typed) {
			const elementContent = element.innerHTML
			typed = true
			element.innerHTML = ''
			element.innerHTML = `${elementContent.charAt(0)}`

			const counterInterval = setInterval(() => {
				element.innerHTML += elementContent.charAt(i)
				i++
				if (element.innerHTML.length >= elementContent.length) {
					clearInterval(counterInterval)
				}
			}, speed)
		}
	}
	runTyping(element)
	// Listen for further  elements
	document.addEventListener('scroll', () => {
		windowScrollPosition = window.scrollY + window.innerHeight
		runTyping(element)
	})
})

// Trzeba nadać klasę CSS  `typing-element` na element, który ma mieć efekt pisania maszynowego
